import type { Category } from "@volgo/core/contract";
import { CATEGORY_INFO, categoryStyle } from "./labels";

/** The coloured square and the Korean name of a category. The only place a category colour is drawn as a mark. */
export function CategoryMark({ category }: { category: Category }) {
  return (
    <span className="cat-mark" style={categoryStyle(category)}>
      {CATEGORY_INFO[category].label}
    </span>
  );
}
